<template>
    <div ref="stockByProductionYears" style="height: 100%"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data() {
            return {
                chart : null,
            }
        },
        props : ['data', 'dealerData', 'selected'],
        mounted () {
            this.createChart()
            // this.dummyData()
            this.generateData()
        },
        watch: {
            selected : function () {
                this.generateData()
            }
        },
        methods: {
            generateData() {
                let length = this.chart.data.length
                let data = []
                
                if (this.selected == 'maindealer')
                    data = this.data.map((x)=>{return{year:x.manufacture_year?x.manufacture_year:'No Year', total:x.total}})
                else if (this.selected == 'dealer')
                    data = this.dealerData.map((x)=>{return{year:x.tahun?x.tahun:'No Year', total:x.total}})

                //Add label no data when data is empty
                if (data.length == 0) data.push({year:'No Data', total:1})
                //If data has more than 5 total years
                else if (data.length > 5) {
                    //Get year 'null' out first
                    let nullData = data.filter(x=>x.year == 'No Year')[0];

                    //If year 'null' exist, take out year 'null'
                    if (nullData) data.splice(data.indexOf(nullData), 1)

                    //Sort data by year then reverse it
                    data.sort((a,b) => (a.year > b.year) ? 1 : ((b.year > a.year) ? -1 : 0)).reverse();

                    //Take only top 5
                    let top5Data = data.splice(0, data.length > 4 ? 5 : 4);
                    if (data.length > 0) {
                        let totalRest = 0
                        //Add total to totalRest
                        data.forEach(x=>totalRest+=x.total)
                        top5Data.push({year:'Other', total:totalRest});
                    }

                    if (nullData) top5Data.push(nullData);
                    data = top5Data.reverse();
                }

                this.chart.addData(data.map(x=>{return{year:x.year.toString(), total:x.total}}), length);
            },
            dummyData () {
                this.data = [
                    {manufacture_year:null, total:100},
                    {manufacture_year:2014, total:10},
                    {manufacture_year:2015, total:10},
                    {manufacture_year:2016, total:10},
                    {manufacture_year:2017, total:10},
                    {manufacture_year:2018, total:10},
                    {manufacture_year:2019, total:10},
                    {manufacture_year:2020, total:30}
                ]
                this.dealerData = [
                    {tahun:null, total:100},
                    {tahun:2014, total:10},
                    {tahun:2015, total:10},
                    {tahun:2016, total:10},
                    {tahun:2017, total:10},
                    {tahun:2018, total:10},
                    {tahun:2019, total:10},
                    {tahun:2020, total:30}
                ]
            },
            createChart() {
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.stockByProductionYears, am4charts.XYChart);

                // Create axes
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "year";
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.renderer.minGridDistance = 30;

                // categoryAxis.renderer.labels.template.adapter.add("dy", function (dy, target) {
                //     if (target.dataItem && target.dataItem.index & 2 == 2) {
                //         return dy + 25;
                //     }
                //     return dy;
                // });

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;

                // Create series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = "total";
                series.dataFields.categoryX = "year";
                series.name = "total";
                series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                series.columns.template.fillOpacity = .8;

                let columnTemplate = series.columns.template;
                columnTemplate.strokeWidth = 2;
                columnTemplate.strokeOpacity = 1;

            }
        }
    }
</script>

<style scoped>

</style>